import { useEffect } from "react";
import { useParams } from "react-router-dom";
import LandingPage, { APP_STORE_URL } from "./LandingPage";

const APP_SCHEME = "gamezz";
const OPEN_APP_DELAY_MS = 2500;
const APP_STORE_FALLBACK_DELAY_MS = 1500;

function DeepLinkGate({ kind }) {
  const { id } = useParams();

  useEffect(() => {
    if (!id) return undefined;

    const deepLink = `${APP_SCHEME}://${kind}/${encodeURIComponent(id)}`;
    let fallbackTimer;

    const openTimer = setTimeout(() => {
      const onVisibilityChange = () => {
        if (document.hidden) {
          clearTimeout(fallbackTimer);
        }
      };
      document.addEventListener("visibilitychange", onVisibilityChange);

      window.location.href = deepLink;

      fallbackTimer = setTimeout(() => {
        document.removeEventListener("visibilitychange", onVisibilityChange);
        if (!document.hidden) {
          window.location.href = APP_STORE_URL;
        }
      }, APP_STORE_FALLBACK_DELAY_MS);
    }, OPEN_APP_DELAY_MS);

    return () => clearTimeout(openTimer);
  }, [id, kind]);

  return <LandingPage />;
}

export default DeepLinkGate;
